// Vuetify Documentation https://vuetifyjs.com
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

import Vue from "vue";
import Vuetify from "vuetify/lib";
import { themePreset } from "../../src/themeConfig";

Vue.use(Vuetify);

export default new Vuetify({
  theme: themePreset.theme,
  rtl: themePreset.rtl
});
